import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import ReactSelect from 'react-select';
import selectStyles from 'components/StyledSelect/react-select-styles.scss';

class LineItemStatus extends Component {
  handleStatusChange = (option) => {
    const lineItem = this.props.lineItem;
    lineItem.status = option.value;
    this.props.onChange(lineItem);
  }

  render = () => {
    const { lineItem, options, cellReadOnly } = this.props;
    const selectOptions = options.map(option => ({ value: option, label: option }));
    return (cellReadOnly ? <Fragment>{lineItem.status}</Fragment> : <ReactSelect
      autoSize={false}
      onChange={this.handleStatusChange}
      options={selectOptions}
      className={`${selectStyles.prettyDropDown}`}
      value={lineItem.status}
      clearable={false}
    />);
  }
}

LineItemStatus.defaultProps = { cellReadOnly: false };

LineItemStatus.propTypes = {
  lineItem: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string),
  cellReadOnly: PropTypes.bool,
};

export default LineItemStatus;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/components/lineItemStatus.jsx